<div class="row">
  <div class="col-xs-12">
    <span *ngIf="title" class="title">{{title}}</span>
    <div class="btn-group" role="group">
      <ng-content></ng-content>
    </div>
  </div>
</div>